/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons } from "../../clients/individualPaymentEditorsController/postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/coupons",
      },
    ] as const;

export type PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationKey
  >;

export function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams["financialPersonId"];
      params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ financialPersonId, params }) => {
      return postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons(
        financialPersonId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Cria o vínculo ativo do código do cupom e soma o desconto no plano (percentual ou valor). Falha quando já existe cupom aplicado, cupom sem código ou plano/cupom inexistente. Migrado do legado IndividualPayment/AddCoupon. **(Requer Authorization para autenticação)**
 * @summary Aplica um cupom ao plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/coupons}
 */
export function usePostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams["financialPersonId"];
        params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams["financialPersonId"];
        params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams["financialPersonId"];
      params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams["financialPersonId"];
      params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams;
    },
    TContext
  >;
}
